import { Box, Typography } from "@mui/material";
import { AlertAdvice } from "components/common/alert-advice";
import NumberField from "components/number-field";
import React, { FC, useState } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useStyles } from "../styles";
import { ProrationForm, ProrationsForm } from "../types";
import { getDefaultProratedAmount, getProrationFormTitle } from "../utils";

type Props = {
  selectedTabIndex: number,
  isLoading: boolean
}

export const ProratedAmount: FC<Props> = ({ selectedTabIndex, isLoading }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { control, formState } = useFormContext<ProrationsForm>();
  const { forms } = useWatch({ control });
  const form = forms && forms.length > 0 ? forms[selectedTabIndex!] as ProrationForm : undefined;
  const title = getProrationFormTitle(form);

  const defaultProratedAmount = getDefaultProratedAmount(formState, selectedTabIndex);

  let showWarningAlert = false;
  if (form && defaultProratedAmount != null && form.proratedAmount?.amount !== defaultProratedAmount) {
    showWarningAlert = true;
  }

  const handleProratedAmountChange = (callback: () => void) => {
    callback();
  };

  return (
    <Box>
      <AlertAdvice
        show={showWarningAlert}
        message={t('orders:proratedAmountWarningMessage')}
        severity="warning"
      />

      <Box style={{ marginTop: "10px" }}>
        <Typography variant="h6" className={classes.subTitle}>
          {title}
        </Typography>

        <Controller
          control={control}
          key={`forms.${selectedTabIndex}.proratedAmount.amount`}
          name={`forms.${selectedTabIndex}.proratedAmount.amount`}
          render={({ field }) => (
            <NumberField
              color="secondary"
              label={t('taxesAndProrations:prorated-amount')}
              name="proratedAmount"
              handleBlur={field.onBlur}
              value={field.value}
              thousandSeparator
              onValueChange={({ floatValue }) => handleProratedAmountChange(() => field.onChange(floatValue ?? 0))}
              prefix="$"
              disabled={isLoading}
            />
          )}
        />
      </Box>
    </Box>
  );
};